import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import VendorHeader from "./../component/VendorHeader";
import VendorFooter from "./../component/VendorFooter";
import $ from "jquery";
import { API_BASE_URL } from "../utils/app_url";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import Sidebar from "../component/Sidebar";

const icon1 = require("./../assets/img/tick.svg").default;
const icon2 = require("./../assets/img/cross.svg").default;

const PlansPricing = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const navigate = useNavigate();

  const [planList, setPlanList] = useState();
  const [activePlan, setActivePlan] = useState();

  const fetchPlanList = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}frontend/plans`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setPlanList(responseData.data);
      } else {
      }
    } catch (error) { }
  };

  const fetchPlanDetails = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}stores/get-plan`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setActivePlan(responseData.data);
      } else {
      }
    } catch (error) { }
  };

  useEffect(() => {
    fetchPlanList();
    fetchPlanDetails();
  }, []);

  // useEffect(() => {
  //   // Add event listener to handle clicks outside the actionDiv
  //   const handleClickOutside = event => {
  //     console.log(actionDivRef.current);
  //     if (setSelectedId && !actionDivRef.current) {
  //       // Clicked outside the actionDiv, so reset selectedId
  //       setSelectedId(null);
  //       console.log("first");
  //     }
  //   };

  //   // Attach the event listener
  //   document.addEventListener("click", handleClickOutside);

  //   // Clean up the event listener on component unmount
  //   return () => {
  //     document.removeEventListener("click", handleClickOutside);
  //   };
  // }, [actionDivRef]);

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
<Sidebar />
<div className="rightSide rightTop">
        
          <div className="plansDiv">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
              <h2 style={{
                  textAlign:"center", width: "100%" }}>{langJson?.plansandpricing}</h2>
              <button
                onClick={() => navigate(-1)}
                style={{
                  padding: "8px 16px",
                  backgroundColor: "#f0f0f0",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
display: "none"
                }}
              >
                {langJson?.back || "Back"}
              </button>
            </div>
            <p>{langJson?.chooseaplan}</p>
          </div>

          <div className="chooseDiv">
            {planList?.map((item, index) => (
              <div className={activePlan?.id === item?.id ? "planList active" : "planList"} key={index}>
                <h2>{item?.name}</h2>
                <h3>
                  <sup>EUR </sup>
                  {item?.price}
                </h3>
                <button
                  onClick={() => navigate(`/plan-subscription/${item?.id}`)}
                  disabled={activePlan?.id === item?.id}
                  style={activePlan?.id === item?.id ? { cursor: "not-allowed" } : {}}
                >
                  {activePlan?.id === item?.id ? langJson?.currentplan : langJson?.getsubscription}
                </button>
                <span dangerouslySetInnerHTML={{ __html: item?.description }}></span>
                {/* <ul>
                  <li>
                    <img src={icon1} alt="" />
                    Own fair stand
                  </li>
                  <li>
                    <img src={icon1} alt="" />
                    Fair stand Live Chat
                  </li>
                  <li>
                    <img src={icon1} alt="" />
                    Fair stand Live Video Chat
                  </li>
                  <li>
                    <img src={icon1} alt="" />
                    Limited fair stand catalog
                  </li>
                  <li>
                    <img src={icon1} alt="" />
                    Limited Slideshow
                  </li>
                  <li>
                    <img src={icon1} alt="" />
                    Limited Video Upload
                  </li>
                  <li className="crossPlan">
                    <img src={icon2} alt="" />
                    *Mobile App
                  </li>
                  <li className="crossPlan">
                    <img src={icon2} alt="" />
                    *B2B Shop
                  </li>{" "}
                </ul> */}
              </div>
            ))}

            {/* <div className="planList active">
              <h2>{langJson?.normal}</h2>
              <h3>
                <sup>EUR </sup>9.99
              </h3>
              <button>{langJson?.getsubscription}</button>
              <ul>
                <li>
                  <img src={icon1} alt="" />
                  Own fair stand
                </li>
                <li>
                  <img src={icon1} alt="" />
                  Fair stand Live Chat
                </li>
                <li>
                  <img src={icon1} alt="" />
                  Fair stand Live Video Chat
                </li>
                <li>
                  <img src={icon1} alt="" />
                  Limited fair stand catalog
                </li>
                <li>
                  <img src={icon1} alt="" />
                  Limited Slideshow
                </li>
                <li>
                  <img src={icon1} alt="" />
                  Limited Video Upload
                </li>
                <li className="crossPlan">
                  <img src={icon2} alt="" />
                  *Mobile App
                </li>
                <li className="crossPlan">
                  <img src={icon2} alt="" />
                  *B2B Shop
                </li>
              </ul>
            </div>

            <div className="planList">
              <h2>{langJson?.professional}</h2>
              <h3>
                <sup>EUR </sup>19.99
              </h3>
              <button>{langJson?.getsubscription}</button>
              <ul>
                <li>
                  <img src={icon1} alt="" />
                  Own fair stand
                </li>
                <li>
                  <img src={icon1} alt="" />
                  Fair stand Live Chat
                </li>
                <li>
                  <img src={icon1} alt="" />
                  Fair stand Live Video Chat
                </li>
                <li>
                  <img src={icon1} alt="" />
                  Limited fair stand catalog
                </li>
                <li>
                  <img src={icon1} alt="" />
                  Limited Slideshow
                </li>
                <li>
                  <img src={icon1} alt="" />
                  Limited Video Upload
                </li>
                <li className="crossPlan">
                  <img src={icon2} alt="" />
                  *Mobile App
                </li>
                <li className="crossPlan">
                  <img src={icon2} alt="" />
                  *B2B Shop
                </li>
              </ul>
            </div> */}
          </div>

        </div>
      </div>
      <VendorFooter />
    </div>
  );
};

export default PlansPricing;
